export default __webpack_public_path__ + "static/media/1151.0480d877.png";